import { stringFormatter } from '../utils';
import {
  getAgreementsApiUrl,
  getCustStateApiUrl,
} from '../selectors/configSelectors';
import { select } from '../stores';
import { myAxaFetchWithToken } from '../utils/myAxaFetchWithToken';

export const PUT_CUST_STATE_REQUEST = `PUT_CUST_STATE_REQUEST`;
export const PUT_CUST_STATE_SUCCESS = `PUT_CUST_STATE_SUCCESS`;

export const FETCH_CUST_STATE_REQUEST = `FETCH_CUST_STATE_REQUEST`;
export const FETCH_CUST_STATE_SUCCESS = `PUT_CUST_STATE_SUCCESS`;

export const FETCH_CUSTOMER_REQUEST = 'FETCH_CUSTOMER_REQUEST';
export const FETCH_CUSTOMER_SUCCESS = 'FETCH_CUSTOMER_SUCCESS';
export const FETCH_CUSTOMER_FAILURE = 'FETCH_CUSTOMER_FAILURE';

export const FETCH_LAUNCHPAD_DATA = 'FETCH_LAUNCHPAD_DATA';
export const FETCH_LAUNCHPAD_DATA_SUCCESS = 'FETCH_LAUNCHPAD_DATA_SUCCESS';

export const FETCH_HAS_SHOWN_LAUNCHPAD = 'FETCH_HAS_SHOWN_LAUNCHPAD';
export const ALREADY_SHOWN_LAUNCHPAD = 'ALREADY_SHOWN_LAUNCHPAD';
export const LAUNCH_TRY_NOW_CLICKED = 'LAUNCH_TRY_NOW_CLICKED';

export const fetchCustomerRequest = () => ({
  type: FETCH_CUSTOMER_REQUEST,
});

export const fetchCustomerSuccess = (customer: any) => ({
  type: FETCH_CUSTOMER_SUCCESS,
  customer,
});

export const fetchCustomerFailure = (error: any) => ({
  type: FETCH_CUSTOMER_FAILURE,
  error,
});

export const fetchLaunchpadData = () => ({
  type: FETCH_LAUNCHPAD_DATA,
});

export const fetchLaunchpadDataSuccess = (data: any) => ({
  type: FETCH_LAUNCHPAD_DATA_SUCCESS,
  data,
});

export const fetchCustState = (key: string, channel: string) => {
  const custApiUrl = select(getCustStateApiUrl);
  return myAxaFetchWithToken(
    `${custApiUrl}?channel=${encodeURI(channel)}&custKey=${encodeURI(key)}`,
    {
      method: 'GET',
    },
  )
    .then((res) => res.json())
    .then((data) => {
      return (data && data.length > 0 && data[0].custValue) || '{}';
    });
};

export type AgreementsStatusResponse = {
  isEnablePIPL: 'Y' | 'N';
  isPIPLChecked: 'Y' | 'N';
  isDMChecked?: 'Y' | 'N';
  isTNCChecked?: 'Y' | 'N';
  isPICChecked?: 'Y' | 'N';
};

export const fetchAgreementsStatus = (featureName: string) => {
  const agreementsApiUrl = select(getAgreementsApiUrl);
  return myAxaFetchWithToken(
    stringFormatter(agreementsApiUrl, { featureName }),
    {
      method: 'GET',
    },
  )
    .then((res) => res.json())
    .then((data) => data as AgreementsStatusResponse);
};

export type PostAgreementsStatusRequest = {
  DM?: boolean;
  PIC?: boolean;
  PIPL?: boolean;
  TNC?: boolean;
};

export const postAgreementsStatus = (
  featureName: string,
  data: PostAgreementsStatusRequest,
) => {
  const agreementsApiUrl = select(getAgreementsApiUrl);
  return myAxaFetchWithToken(
    stringFormatter(agreementsApiUrl, { featureName }),
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  ).then((res) => res.status);
};

export const putCustState = (
  custKey: string,
  custValue: string,
  channel: string,
  featureName?: string,
  withoutEncodeURI?: boolean,
) => {
  const custApiUrl = select(getCustStateApiUrl);
  const changedCustApiUrl = featureName
    ? `${custApiUrl}?featureName=${featureName}`
    : custApiUrl;
  return myAxaFetchWithToken(`${changedCustApiUrl}`, {
    method: 'POST',
    body: JSON.stringify({
      insertCustomerStateRequest: {
        channelCode: withoutEncodeURI ? channel : encodeURI(channel),
        custKey: withoutEncodeURI ? custKey : encodeURI(custKey),
        custValue: withoutEncodeURI ? custValue : encodeURI(custValue),
      },
    }),
  }).then((res) => res.status);
};

export const triggerTryNowButton = () => ({
  type: LAUNCH_TRY_NOW_CLICKED,
});

export const getLaunchpadState = () => {
  return {
    type: FETCH_HAS_SHOWN_LAUNCHPAD,
  };
};

export const setLaunchpadState = () => {
  return {
    type: ALREADY_SHOWN_LAUNCHPAD,
  };
};
